import * as React from "react";
const SvgError = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M8.00004 1.33301C4.32004 1.33301 1.33337 4.31967 1.33337 7.99967C1.33337 11.6797 4.32004 14.6663 8.00004 14.6663C11.68 14.6663 14.6667 11.6797 14.6667 7.99967C14.6667 4.31967 11.68 1.33301 8.00004 1.33301Z",
	fill: "#F95721"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.66671 11.3333H7.33337V10H8.66671V11.3333Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.66671 8.66699H7.33337V4.66699H8.66671V8.66699Z",
	fill: "white"
}));
export default SvgError;
